import {
  type PDPdownloadPdfFile,
  type ProductData,
  type PublicationDownloadFile,
} from "~/domains/product/types/ProductData";
import {
  type SpecificationBandData,
  type variantGroupProductDTO,
} from "~/features/productDetails/dto/PdpPageProductDataDto";
import { type FootnoteDTO, type ImageDataDTO } from "~/domains/product/types/ProductDataDTO";
import { type ClusterItem } from "~/features/selectionAssistant/bearing/types";
import type { TechnicalInfoData } from "~/features/search/models/SearchResultsDTO";

export type PdpPageProductData = ProductData & {
  description: string;
  specificationBand: SpecificationBandData[];
  techImages: ImageDataDTO[];
  preferredProductsFamilyName: string;
  tracePartsOrderNo: string;
  tracePartsUrl: string;
  bearingXDesignation: string | null;
  mountingManagerURL: string;
  greaseAppUrl: string;
  footnotes: FootnoteDTO[];
  attributeIcons: ClusterItem[];
  commentsFootnotes: FootnoteDTO[];
  downloads: PDPdownloadPdfFile[];
  mountingPublicationsDownloads: PDPdownloadPdfFile[];
  publications: PublicationDownloadFile[];
  gpsdGroup: string | null;
  showBasicFrequencies: boolean | null;
  showRohsDownload: boolean;
  unitTag: UnitTagType;
  technicalInfo?: TechnicalInfoData;
  variantGroupProductList: variantGroupProductDTO[];
};

export type PreferredProductData = Pick<
  ProductData,
  "designation" | "code" | "sapMaterialNumber" | "url" | "preferred" | "images" | "stockAmount"
>;

export type RelatedProductData = Pick<
  ProductData,
  | "designation"
  | "sapMaterialNumber"
  | "aliases"
  | "shortDescription"
  | "preferred"
  | "url"
  | "images"
  | "manufacturerLogoUrl"
  | "code"
  | "productAllCategories"
  | "quantityVisible"
  | "stockAmount"
>;

export enum UnitTagType {
  Metric = "TRUEMETRIC",
  Imperial = "TRUEIMPERIAL",
  Hybrid = "HYBRID",
}

const MAP = {
  TRUEMETRIC: UnitTagType.Metric,
  TRUEIMPERIAL: UnitTagType.Imperial,
  HYBRID: UnitTagType.Hybrid,
};

export function getUnitTagFromString(val?: string | null): UnitTagType {
  if (!val) {
    throw new Error("unit type cannot be null!");
  }
  const upperVal = val.toUpperCase() as keyof typeof MAP;
  const value = MAP[upperVal];
  if (!value) {
    throw new Error("unit type cannot be null!");
  }
  return value;
}
